import { z } from 'zod';

/** The filters of the feed besides "all" (the absence of a filter). */
export const ACTIVITY_SEARCH_FILTERS = ['mentions', 'assignments', 'approvals'] as const;

/**
 * Search params of /o/$orgId/activity: the filter of the feed, kept in the address so a view can
 * be shared and survives a reload. An invalid value is simply dropped.
 */
export const ActivitySearchSchema = z.object({
  filter: z.enum(ACTIVITY_SEARCH_FILTERS).optional().catch(undefined),
});
export type ActivitySearch = z.infer<typeof ActivitySearchSchema>;
